import { render, staticRenderFns } from "./dashboard-flag.vue?vue&type=template&id=a6d06a30"
import script from "./dashboard-flag.vue?vue&type=script&lang=ts"
export * from "./dashboard-flag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6d06a30')) {
      api.createRecord('a6d06a30', component.options)
    } else {
      api.reload('a6d06a30', component.options)
    }
    module.hot.accept("./dashboard-flag.vue?vue&type=template&id=a6d06a30", function () {
      api.rerender('a6d06a30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/flag/dashboard-flag.vue"
export default component.exports